<template>
  <div id="allies" class="section">
    <div class="container">
      <h3 class="is-size-3">{{ $t("allies.tittle") }}</h3>
      <hr class="line" />
      <br />
      <div id="grid-allies" class="columns is-multiline">
        <div
          class="column is-one-quarter has-text-centered"
          v-for="(ally, index) in slides"
          :key="index"
        >
          <img
            data-aos="fade-left"
            :data-aos-delay="index"
            data-aos-duration="300"
            v-bind:src="getImgUrl(ally.img)"
            :alt="ally.img"
            style="width: 80%; height: 100px; object-fit: contain"
          />
          <!-- <hr />
          <h5 class="has-text-centered has-text-grey-light">{{ ally.name }}</h5> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Allies",
  data() {
    return {
      slides: [
        {
          name: "Asociación insurtech colombia",
          img: "allies/aic.png",
        },
        {
          name: "Close Agile consulting",
          img: "allies/closer-agile.png",
        },
        {
          name: "Camara de comercio e industria de colombo chilena",
          img: "allies/ccicc.png",
        },
        {
          name: "DTC Security",
          img: "allies/dtc-security.png",
        },
        {
          name: "hcs-capital",
          img: "allies/hcs-capital.png",
        },
        {
          name: "Corfo",
          img: "allies/corfo.png",
        },
        {
          name: "addventures",
          img: "allies/addventures.png",
        },
        {
          name: "universidad-alfonso-ibanez",
          img: "allies/universidad-alfonso-ibanez.png",
        },
        {
          name: "AZ",
          img: "allies/az.png",
        },
        {
          name: "ProChile",
          img: "allies/prochile.png",
        },
        {
          name: "Deloitte",
          img: "allies/deloitte.png",
        },
        {
          name: "Insurtech Chile",
          img: "allies/insurtech.png",
        },
        {
          name: "Innova Connect",
          img: "allies/innovaconnect360.png",
        },
        {
          name: "Pro America",
          img: "allies/proamerica.png",
        },
      ],
    };
  },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/img/" + pic);
    },
  },
};
</script>
<i18n>
{
  "es": {
    "allies": {
      "tittle": "Nuestras Alianzas"
    }
  },
  "en": {
    "allies": {
    "tittle": "Our alliances"
    }
  },
  "pt": {
    "allies": {
      "tittle": "Nossas alianças"
    }
  }
}
</i18n>
